import React, { useState } from 'react';
import { BiDetail, BiMenuAltRight } from 'react-icons/bi';
import { FiDollarSign } from 'react-icons/fi';
import { MdChevronLeft } from 'react-icons/md';
import { RiHistoryFill } from 'react-icons/ri';
import { useLocation, useHistory } from 'react-router-dom';
import { BsChatSquareText, BsPrinter, BsShieldExclamation } from 'react-icons/bs';
import { Container, ItemMenu, TextItem, Div, Subtitle, ModalButton, Description, MobileMenu } from './styles';
import { Dialog, Button } from 'components';
import { VscCloseAll } from 'react-icons/vsc';
import { BiBarcodeReader } from 'react-icons/bi';
import { toast } from 'react-toastify';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import api from 'api';
import Cookies from 'js-cookie';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import settings from 'settings.json';
import { hasPermission } from 'utils/general';

function BackofficeMenu({ policyId, onCancel, policyData, hasProducts, hasProviderSupport }) {
  const location = useLocation();
  const path = location.pathname;
  const history = useHistory();

  const permissionsCookie = Cookies.get('splitrisk-backoffice-permissions');
  const permissions = permissionsCookie ? JSON.parse(permissionsCookie) : null;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openAssistanceModal, setOpenAssistanceModal] = useState(false);
  const [assistanceInfo, setAssistanceInfo] = useState({
    loading: true,
    active: false,
    date: '',
  });
  const [textInput, setTextInput] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [substatus, setSubstatus] = useState('');

  const handleCancelPolicy = async (e) => {
    setLoadingCancel(true);
    try {
      await api({
        method: 'POST',
        url: `/backoffice-cancel-policy`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: {
          id: policyId,
          description: textInput,
          substatus: substatus,
        },
        json: true,
      });
      setLoadingCancel(false);
      handleClose();
      window.location.reload();
    } catch (e) {
      setLoadingCancel(false);

      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  const handleClickOpen = () => {
    setOpenCancelModal(true);
  };

  const handleClose = () => {
    setOpenCancelModal(false);
  };

  const handleOpenAssistance = () => {
    setOpenAssistanceModal(true);
    setAssistanceInfo({ loading: true, active: false, date: '' });
    getPolicyAssistance();
  };

  const handleCloseAssistance = () => {
    setOpenAssistanceModal(false);
    setAssistanceInfo({ loading: false, active: false, date: '' });
  };

  const getPolicyAssistance = async () => {
    try {
      const resp = await api({
        method: 'GET',
        url: `/policy-assistance/${policyId}`,
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
      });

      const { data } = resp;
      setAssistanceInfo({
        loading: false,
        active: data?.active,
        date: data?.date,
      });
    } catch (e) {
      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  const handlePolicyAssistance = async () => {
    try {
      setAssistanceInfo({ ...assistanceInfo, loading: true });
      await api({
        method: 'PATCH',
        url: `/policy-assistance/${policyId}`,
        data: {
          active: assistanceInfo.active,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        json: true,
      });
      toast.success('Assistência atualizada com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } catch (e) {
      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      handleCloseAssistance();
    }
  };

  return (
    <>
      <Dialog
        open={openAssistanceModal}
        title={
          assistanceInfo.loading
            ? 'Carregando...'
            : `Confirmar ${assistanceInfo.active ? 'desativação' : 'ativação'} de assistência`
        }
        width="450px"
        onConfirm={handlePolicyAssistance}
        onCancel={handleCloseAssistance}
        loading={assistanceInfo.loading}
      >
        <Subtitle hide={assistanceInfo.loading}>
          Tem certeza de que deseja {assistanceInfo.active ? 'desativar' : 'ativar'} a assistência para esse contrato?
        </Subtitle>
        {!!assistanceInfo.active && <Subtitle hide={assistanceInfo.loading}>Data de ativação: {assistanceInfo.date}</Subtitle>}
        <ModalButton>
          <Button
            height="35px"
            style={{ background: 'transparent', border: '1.5px solid #62ec83' }}
            onClick={handleCloseAssistance}
          >
            Voltar
          </Button>
          <Button
            height="35px"
            style={{
              background: assistanceInfo.active ? 'red' : '#62ec83',
              color: assistanceInfo.active ? 'white' : 'black',
              border: 'none',
            }}
            loading={assistanceInfo.loading}
            onClick={handlePolicyAssistance}
          >
            Concluir {assistanceInfo.active ? 'desativação' : 'ativação'}
          </Button>
        </ModalButton>
      </Dialog>
      <MobileMenu>
        <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
          <BiMenuAltRight size={26} />
        </IconButton>

        <Menu
          style={{ marginTop: '50px', marginLeft: '-40px' }}
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => {
              history.push('/backoffice/contratos');
            }}
          >
            <MdChevronLeft size="18" />
            <TextItem>Contratos</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes('/backoffice/detalhes-do-contrato')}
            onClick={() => {
              history.push(`/backoffice/detalhes-do-contrato/${policyId}`);
            }}
          >
            <BiDetail size="18" />
            <TextItem>Detalhes</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes('/backoffice/historico-do-contrato')}
            onClick={() => {
              history.push(`/backoffice/historico-do-contrato/${policyId}`);
            }}
          >
            <RiHistoryFill size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Histórico do contrato</TextItem>
          </MenuItem>

          {hasProducts && (
            <ItemMenu
              onClick={() => {
                window.open(`/backoffice/detalhes-do-contrato/${policyId}/imprimir-documento-complementar`, '_blank');
              }}
            >
              <BsPrinter size="20" style={{ marginLeft: '15px' }} />
              <TextItem>Documento complementar</TextItem>
            </ItemMenu>
          )}

          <MenuItem
            selected={path.includes('/backoffice/faturas')}
            onClick={() => {
              history.push(`/backoffice/faturas/${policyId}`);
            }}
          >
            <FiDollarSign size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Faturas</TextItem>
          </MenuItem>

          <MenuItem
            selected={path.includes('/backoffice/historico-reclamacao')}
            onClick={() => {
              history.push(`/backoffice/historico-reclamacao/${policyId}`);
            }}
          >
            <BsChatSquareText size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Reclamações</TextItem>
          </MenuItem>

          {policyData?.status === 'active' && (
            <MenuItem onClick={onCancel}>
              <VscCloseAll size="18" style={{ marginRight: '-3px' }} />
              <TextItem onClick={handleClickOpen}>Cancelar seguro</TextItem>

              <>
                <Dialog
                  open={openCancelModal}
                  title="Confirmar cancelamento"
                  width="450px"
                  onConfirm={handleCancelPolicy}
                  onCancel={handleClose}
                  loading={loading}
                >
                  <Div>
                    <Subtitle>Tem certeza de que deseja cancelar esse contrato? O cancelamento não poderá ser desfeito!</Subtitle>
                    <Description>
                      <TextareaAutosize
                        minRows={1}
                        onChange={(e) => setTextInput(e.target.value)}
                        value={textInput}
                        placeholder="Observações..."
                        style={{
                          padding: 10,
                          fontFamily: 'Nunito',
                          fontSize: 14,
                          marginTop: '3%',
                          width: '100%',
                          height: '100px',
                          borderRadius: 5,
                          borderColor: '#d1d2d4',
                        }}
                      />
                    </Description>
                  </Div>
                  <ModalButton>
                    <Button
                      height="35px"
                      style={{ background: 'transparent', border: '1.5px solid #62ec83' }}
                      onClick={handleClose}
                      loading={loadingCancel}
                    >
                      Voltar
                    </Button>
                    <Button height="35px" style={{ background: '#62ec83', border: 'none' }} onClick={handleCancelPolicy}>
                      Concluir cancelamento
                    </Button>
                  </ModalButton>
                </Dialog>
              </>
            </MenuItem>
          )}

          <MenuItem onClick={() => window.open(settings?.claim_url)}>
            <BsShieldExclamation size="18" style={{ marginRight: '-3px' }} />
            <TextItem onClick={handleClickOpen}>Comunicar sinistro</TextItem>
          </MenuItem>

          {hasProviderSupport && hasPermission(permissions, 'atualizar-assistencia') && (
            <MenuItem onClick={onCancel}>
              <VscCloseAll size="18" style={{ marginRight: '-3px' }} />
              <TextItem onClick={handleOpenAssistance}>Assistência</TextItem>
            </MenuItem>
          )}
        </Menu>
      </MobileMenu>

      <Container>
        <ItemMenu
          onClick={() => {
            history.push('/backoffice/contratos');
          }}
        >
          <MdChevronLeft size="18" />
          <TextItem>Contratos</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes('/backoffice/detalhes-do-contrato') && 'select'}
          onClick={() => {
            history.push(`/backoffice/detalhes-do-contrato/${policyId}`);
          }}
        >
          <BiDetail size="18" />
          <TextItem>Detalhes</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes('/backoffice/historico-do-contrato') && 'select'}
          onClick={() => {
            history.push(`/backoffice/historico-do-contrato/${policyId}`);
          }}
        >
          <RiHistoryFill size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Histórico do Contrato</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes('/backoffice/listar-documentos-contrato') && 'select'}
          onClick={() => {
            history.push(`/backoffice/listar-documentos-contrato/${policyId}`);
          }}
        >
          <BsPrinter size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Imprimir Documento</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes('/backoffice/listar-apolices-contrato') && 'select'}
          onClick={() => {
            history.push(`/backoffice/listar-apolices-contrato/${policyId}`);
          }}
        >
          <BsPrinter size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Imprimir Apólice</TextItem>
        </ItemMenu>

        {hasProducts && (
          <ItemMenu
            onClick={() => {
              window.open(`/backoffice/detalhes-do-contrato/${policyId}/imprimir-documento-complementar`, '_blank');
            }}
          >
            <BsPrinter size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Imprimir documento complementar</TextItem>
          </ItemMenu>
        )}

        <ItemMenu
          className={path.includes('/backoffice/faturas') && 'select'}
          onClick={() => {
            history.push(`/backoffice/faturas/${policyId}`);
          }}
        >
          <FiDollarSign size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Faturas</TextItem>
        </ItemMenu>

        <ItemMenu
          className={path.includes('/backoffice/historico-reclamacao') && 'select'}
          onClick={() => {
            history.push(`/backoffice/historico-reclamacao/${policyId}`);
          }}
        >
          <BsChatSquareText size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Reclamações</TextItem>
        </ItemMenu>

        {(policyData?.status === 'active' || policyData?.status === 'awaiting_cancellation') && (
          <ItemMenu onClick={onCancel}>
            <VscCloseAll size="18" style={{ marginRight: '-3px' }} />
            <TextItem onClick={handleClickOpen}>Cancelar seguro</TextItem>

            <>
              <Dialog
                open={openCancelModal}
                title="Confirmar cancelamento"
                width="450px"
                onConfirm={handleCancelPolicy}
                onCancel={handleClose}
                loading={loading}
              >
                <Div>
                  <Subtitle>Tem certeza de que deseja cancelar este contrato? O cancelamento não poderá ser desfeito!</Subtitle>
                  <Description>
                    <TextareaAutosize
                      minRows={1}
                      maxLength={100}
                      onChange={(e) => setTextInput(e.target.value)}
                      value={textInput}
                      placeholder="Descreva o motivo do cancelamento"
                      style={{
                        padding: 10,
                        fontFamily: 'Nunito',
                        fontSize: 14,
                        marginTop: '3%',
                        width: '100%',
                        height: '100px',
                        borderRadius: 5,
                        borderColor: '#d1d2d4',
                      }}
                    />
                  </Description>
                </Div>
                <ModalButton>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'space-between',
                      gap: '15px',
                      width: '100%',
                      marginTop: '3%',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '6px' }}>
                      <label style={{ fontFamily: 'Nunito', fontSize: 11, marginLeft: '8px' }}>Motivos</label>
                      <select
                        value={substatus}
                        onChange={(e) => setSubstatus(e.target.value)}
                        style={{
                          height: '35px',
                          width: '75%',
                          borderRadius: 12,
                          borderColor: '#d1d2d4',
                          marginBottom: '8px',
                        }}
                      >
                        <option value="">Selecione...</option>
                        <option value="customer_request">Desistiu do seguro</option>
                        <option value="commercial_dissatisfaction">Insatisfação comercial</option>
                        <option value="financial_difficulty">Sem condições financeiras</option>
                        <option value="vehicle_replacement">Substituição de veículo</option>
                        <option value="total_loss">Veículo indenizado</option>
                        <option value="vehicle_sold">Veículo vendido</option>
                      </select>
                    </div>
                    <Button
                      height="35px"
                      style={{ background: 'transparent', border: '1.5px solid #62ec83' }}
                      onClick={handleClose}
                    >
                      Voltar
                    </Button>

                    <Button
                      height="35px"
                      style={{ background: '#62ec83', border: 'none' }}
                      disabled={!substatus}
                      onClick={handleCancelPolicy}
                      loading={loadingCancel}
                    >
                      Concluir cancelamento
                    </Button>
                  </div>
                </ModalButton>
              </Dialog>
            </>
          </ItemMenu>
        )}
        <ItemMenu onClick={() => window.open(settings?.claim_url)}>
          <BsShieldExclamation size="18" style={{ marginRight: '-3px' }} />
          <TextItem>Comunicar sinistro</TextItem>
        </ItemMenu>

        {hasProviderSupport && hasPermission(permissions, 'atualizar-assistencia') && (
          <ItemMenu onClick={handleOpenAssistance}>
            <BsShieldExclamation size="18" style={{ marginRight: '-3px' }} />
            <TextItem>Assistência</TextItem>
          </ItemMenu>
        )}
      </Container>
    </>
  );
}

export default BackofficeMenu;
